import { Box, Typography, styled } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useProductsPriceSWR from '../../hooks/products/useProductsPriceSWR';
import { ProductPricesProp } from '../../models/ProductPage';
import { formatPrice } from '../../utils/numberFormatter';
import { getCurrency, getNetPrice, getShopifyID } from '../../utils/utils';
import { SingleItemLoading } from '../layouts/LoadingLayouts/SingleItemLoading';

const StyledPriceWrapper = styled(Box)(() => ({
    display: 'flex',
    paddingTop: '15px',
}));

const StyledElement = styled(Box)(() => ({
    flex: '0 0 50%',
}));

const StyledNetPrice = styled(Typography)(() => ({
    fontWeight: 'bold',
    fontSize: '26px',
    color: '#2b7291',
}));

export const ProductPrices: React.FC<ProductPricesProp> = (props) => {
    const { variant, productId } = props;
    const { t } = useTranslation('product');

    const { prices, isLoading, extractCustomPrices, getMinCustomPrice } =
        useProductsPriceSWR([+productId]);

    const [price, setPrice] = useState<number>(0);

    useEffect(() => {
        if (isLoading) return;

        const customs = extractCustomPrices(
            prices,
            getShopifyID(productId),
            getShopifyID(variant.id)
        );

        if (!customs) {
            setPrice(getNetPrice(+variant.price.amount));
            return;
        }

        const minNetPrice = getMinCustomPrice(customs, 1);

        setPrice(+minNetPrice?.net_price);
    }, [isLoading, prices]);

    return (
        <>
            <StyledPriceWrapper>
                <StyledElement>
                    <Typography>{t('PRODUCT.NET')}</Typography>
                    {isLoading && <SingleItemLoading />}
                    {!isLoading && (
                        <StyledNetPrice>
                            {formatPrice(price)}{' '}
                            {getCurrency(variant.price.currencyCode)}
                        </StyledNetPrice>
                    )}
                </StyledElement>
            </StyledPriceWrapper>
        </>
    );
};
